(function () {
  if (window.gracoPetPersonalizationLoaded) return;
  window.gracoPetPersonalizationLoaded = true;

  const MAX_BYTES = 10 * 1024 * 1024;
  const ALLOWED_TYPES = ['image/jpeg', 'image/png'];

  function blockForForm(form) {
    return document.querySelector(`[data-pet-personalization][data-form-id="${CSS.escape(form.id)}"]`);
  }

  function setStatus(block, message, isError) {
    const status = block.querySelector('[data-pet-upload-status]');
    if (!status) return;
    status.textContent = message;
    if (isError) status.setAttribute('aria-invalid', 'true');
    else status.removeAttribute('aria-invalid');
  }

  function validate(block) {
    const name = block.querySelector('[data-pet-name]');
    const photo = block.querySelector('[data-pet-photo]');
    const file = photo.files && photo.files[0];
    name.setCustomValidity(name.value.trim() ? '' : "Please enter your pet's name.");
    photo.setCustomValidity('');
    if (!file) photo.setCustomValidity('Please choose a photo.');
    else if (!ALLOWED_TYPES.includes(file.type)) photo.setCustomValidity('Please choose a JPG or PNG photo.');
    else if (!file.size) photo.setCustomValidity('This photo is empty. Please choose another file.');
    else if (file.size > MAX_BYTES) photo.setCustomValidity('Please choose a photo smaller than 10 MB.');
    return name.reportValidity() && photo.reportValidity();
  }

  function signature(file) {
    return `${file.name}:${file.size}:${file.lastModified}`;
  }

  function setProperty(form, name, value) {
    let input = form.querySelector(`input[data-pet-property="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.dataset.petProperty = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  async function uploadPhoto(block, file) {
    const endpoint = block.dataset.uploadEndpoint.replace(/\/$/, '');
    if (!endpoint) throw new Error('Photo upload service is not configured.');
    const response = await fetch(`${endpoint}/upload`, {
      method: 'POST',
      headers: { 'Content-Type': file.type, 'X-File-Name': encodeURIComponent(file.name) },
      body: file
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result.downloadUrl) throw new Error(result.error || 'Photo upload failed. Please try again.');
    return result;
  }

  document.addEventListener('change', function (event) {
    const photo = event.target.closest('[data-pet-photo]');
    if (!photo) return;
    const block = photo.closest('[data-pet-personalization]');
    const file = photo.files && photo.files[0];
    const preview = block.querySelector('[data-pet-preview]');
    const previewImage = block.querySelector('[data-pet-preview-image]');
    const fileLabel = block.querySelector('[data-pet-file-label]');
    block.dataset.uploadedSignature = '';
    setStatus(block, '', false);
    if (!file) {
      preview.hidden = true;
      fileLabel.textContent = 'JPG or PNG, up to 10 MB';
      return;
    }
    fileLabel.textContent = file.name;
    previewImage.src = URL.createObjectURL(file);
    preview.hidden = false;
  });

  document.addEventListener('click', function (event) {
    const changeButton = event.target.closest('[data-pet-photo-change]');
    if (!changeButton) return;
    changeButton.closest('[data-pet-personalization]').querySelector('[data-pet-photo]').click();
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.id) return;
    const block = blockForForm(form);
    if (!block) return;
    const photo = block.querySelector('[data-pet-photo]');
    const file = photo.files && photo.files[0];
    if (!validate(block)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const fileSignature = signature(file);
    if (block.dataset.uploadedSignature === fileSignature) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.disabled = true;
    setStatus(block, 'Uploading your original photo…', false);
    try {
      const result = await uploadPhoto(block, file);
      setProperty(form, 'Original Photo', result.downloadUrl);
      setProperty(form, 'Photo Filename', result.filename || file.name);
      block.dataset.uploadedSignature = fileSignature;
      setStatus(block, 'Photo uploaded securely. Adding your item…', false);
      if (submitter) submitter.disabled = false;
      form.requestSubmit(submitter || undefined);
    } catch (error) {
      setStatus(block, error.message || 'Photo upload failed. Please try again.', true);
      if (submitter) submitter.disabled = false;
    }
  }, true);
})();
